import store from 'store2';
import jwtDecode from 'jwt-decode';
import config from '../../../config';

export default () => jwtDecode(store.get(config.auth.idTokenKey));



// WEBPACK FOOTER //
// ./src/common/auth/utils/getDecodedToken.js